import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, blur } from 'redux-form';
import PropTypes from 'prop-types';
import { isEmpty } from '../../../../shared-components/FormElement/FormElementUtils';
import TextField from '../../../../shared-components/TextField/TextField';
import { injectIntl, intlShape } from 'react-intl';
import { phoneNormalize, isPhoneValid, formatNumber } from './PhoneNumberUtils';
import { FORM_ID } from '../../../../framework/App/AppConstants';

const LOCALE_PREFIX = 'DE/components/PhoneGroup/PhoneNumber';

export class PhoneNumber extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        formatNumberOnBlur: PropTypes.func.isRequired,
    };

    render() {
        const { intl, formatNumberOnBlur } = this.props;

        return (
            <Field
                id="telephoneDE"
                name="telephone"
                type="tel"
                required={true}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                component={TextField}
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.label`})}
                validate={[
                    isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.PHONE_IS_NULL`})),
                    isPhoneValid(intl.formatMessage({id: `${LOCALE_PREFIX}.PHONE_INVALID_FORMAT`}))
                ]}
                normalize={phoneNormalize}
                onBlur={formatNumberOnBlur}
            />
        );
    }
}

export const mapDispatchToProps = dispatch => ({
    formatNumberOnBlur(event, newValue, previousValue) {
        let formattedValue;
        try {
            formattedValue = formatNumber(newValue);
        } catch (e) {
            formattedValue = newValue;
        }
        event.preventDefault();
        dispatch(blur(FORM_ID, 'personal-info.telephone', formattedValue));
    }
});

export default connect(null, mapDispatchToProps)(injectIntl(PhoneNumber));
